import image1 from "../images/review profile.png";
import image2 from "../images/review profile1.png";
import image3 from "../images/review profile2.png";

const ReviewData = [
  {
    id: 1,
    name: "Esther Oluwafemi",
    image: image1,
    review:
      "Taking a chance with Rigvidon was the best decision my company made this year, speedy delivery of all their services, projects being carried out with a high level of excellence and efficiency. There has never been a need to complain or worry. It was like we had found home.",
  },
  {
    id: 2,
    name: "Tona Okafor",
    image: image2,
    review:
      "Ever since I started training my engineers with Rigvidon the quality of the services my company offered skyrocketed . Now we organize a training conference with them once a year. And it has really been paying off",
  },
  {
    id: 3,
    name: "Balogun Damola",
    image: image3,
    review:
      "Rigvidon handles all the process engineering activities my company engages in. So far, we haven’t had any reason to complain",
  },
];
export default ReviewData;
